/* Ayudate · 404
   Se muestra cuando la dirección no coincide con ninguna ruta conocida
   (ver RUTAS en lib/rutas.js). */

import React from "react";
import { Marca } from "../componentes/Marca";
import { ESTILOS_MINIMOS } from "../estilos/minimos";
import { irA_ruta } from "../lib/rutas";

export function Pagina404() {
  return (
    <div className="v2">
      <style>{ESTILOS_MINIMOS}</style>
      <div className="mini-wrap">
        <div className="logo" style={{ marginBottom: 28 }}><Marca /></div>
        <div className="mini-card" style={{ textAlign: "center" }}>
          <h1>404 - Página no encontrada</h1>
          <p>
            La dirección a la que intentó entrar no existe o se movió. Revise el enlace, o
            vuelva al inicio y busque lo que necesita desde ahí.
          </p>
          <a className="btn btn-p" href="/" style={{ width: "100%", textAlign: "center", display: "block" }}
            onClick={(e) => { e.preventDefault(); irA_ruta("/"); }}>
            Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
}
